module.exports = __webpack_public_path__ + "static/media/zhuyeqing.1ba50d2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/zhuyeqing.mp4
// module id = SqUe
// module chunks = 0